module.exports = __webpack_public_path__ + "img/suitable_small.183924b7.svg";